export default {
  "foot": {
    "title": "Игроки Century Games",
    "p1": "Введите ваш игровой ID и заплатите за пополнение счёта. Эта сумма напрямую появится на вашем соответствующем аккаунте. Если этого не произойдёт, пожалуйста, перезагрузите игру или, по необходимости, свяжитесь со службой поддержки.",
    "p2": "Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь с нашей службой клиентской поддержки. Благодарим вас за поддержку!",
    "copyright": "© Century Games, 2024",
    "service": "Пользовательское соглашение",
    "policy": "Политика конфиденциальности",
    "descriptionTitle": "Как это работает?"
  },
  "accept": {
    "title": "Этот сайт использует файлы cookie для максимально эффективной навигации по страницам. Пожалуйста, прочтите нашу <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">политику конфиденциальности</a>, чтобы узнать, что мы собираем на нашем сайте. Продолжая использовать этот сайт, вы соглашаетесь на то, чтобы мы хранили файлы cookie на вашем устройстве и имели к ним доступ.",
    "decline": "Отказаться",
    "accept": "Принять"
  },
  "game": {
    "inapptext": "Или зайдите через игру",
    "loginfail": "Не удалось войти",
    "logintip": "Если авторизация через игру не удалась, пожалуйста, обновите игру до самой свежей версии или попробуйте в другом браузере.",
    "reloadmsg": "Чтобы увидеть результаты входа, пожалуйста, нажмите на кнопку «Перезагрузить».",
    "reload": "Перезагрузить",
    "appnotice": "Если вы хотите зайти через приложение игры, пожалуйста, используйте внешний браузер для открытия магазина.",
    "changeaccount": "Вы точно хотите выйти из аккаунта?",
    "login": "Войти",
    "notice": "Уведомление",
    "confirm": "Подтвердить",
    "loginuserid": "ID пользователя",
    "palceholder": "Введите ID пользователя",
    "okbtn": "ОК",
    "loginbtn": "Войти через игру",
    "changebtn": "Или войти через ID пользователя",
    "useTitle": "АККАУНТ",
    "checkBtn": "Проверить",
    "findid": "Не можете найти свой ID пользователя?",
    "checktext": "Как правило, ID расположен в настройках. Нажмите на знак вопроса, чтобы получить дальнейшую помощь.",
    "username": "Игровое имя:",
    "userId": "ID пользователя:",
    "packageTitle": "СУММА ПОПОЛНЕНИЯ",
    "edit": "Поменять",
    "paymentTitle": "СПОСОБ ПЛАТЕЖА",
    "total": "Итог",
    "goPay": "Заплатить",
    "noSelectPackageTips": "Вы не выбрали сумму",
    "payFail": "ПЛАТЁЖ НЕ ПРОШЁЛ",
    "camelPayfail": "Платёж не прошёл",
    "payFailTips1": "Свяжитесь со службой поддержки Adyen",
    "payFailTips2": "Свяжитесь со службой поддержки PayPal",
    "paySuccess": "ПЛАТЁЖ ПРОШЁЛ",
    "paySuccessTips2": "Если вы не получили покупку, перезагрузите игру перед тем, как связаться со службой поддержки!",
    "camelPaySuccess": "Платёж прошёл",
    "transactionId": "ID транзакции",
    "paySuccessTips": "Доставка предметов может занять пару минут, пожалуйста, подождите",
    "deliveryFail": "ДОСТАВКА НЕ УДАЛАСЬ",
    "deliveryFailTips": "Свяжитесь со службой поддержки",
    "orderTitle": "Сводка по заказу",
    "paidWith": "Способ платежа",
    "orderID": "ID транзакции",
    "payStatus": "Статус платежа",
    "orderTotal": "Общая цена",
    "transactionDate": "Дата транзакции",
    "goOnPay": "Сделать ещё покупку",
    "getInvoice": "Чек",
    "camelDeliveryFail": "Доставка не удалась",
    "confirmOrder": "ПОДТВЕРЖДЕНИЕ ЗАКАЗА",
    "confirmFollow": "Пожалуйста, подтвердите следующее:",
    "nickname": "Игровое имя",
    "packageName": "Предметы",
    "totalPayment": "Общая цена",
    "confirmPayWith": "Способ платежа",
    "confirmAndGoOn": "Подтвердить и оплатить",
    "orderCancel": "Отмена",
    "getInvoiceTitle": "ОТПРАВИТЬ ПО ПОЧТЕ",
    "getInvoiceTips": "Если вы хотели бы получить чек по почте, пожалуйста, введите вашу электронную почту.",
    "getInvoiceTips1": "Введите почту здесь, чтобы получить чек",
    "getInvoiceTips2": "Я соглашаюсь на сбор  и хранение адреса моей электронной почты.",
    "getInvoiceTips3": "Я соглашаюсь получать по этой почте письма о скидках, промоакциях и т. д. для наших игр.",
    "invoiceSend": "Отправить",
    "sendSuccess": "Письмо с чеком отправлено",
    "id404": "ID пользователя не найден",
    "packageLoadingText": "Предметы в магазине обновляются...",
    "taxTips": "Цена включает налог",
    "adyenTips": "Платежный сервис предоставлен компанией Adyen, действующей при наличии лицензии на ведение банковских операций и под присмотром Нидерландского банка. Если у вас есть какие-либо вопросы о сертификатах компании, пожалуйста, загляните сюда: <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Чтобы узнать, как эта компания защищает ваши данные, пожалуйста, загляните сюда: <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Платежный сервис предоставлен компанией PayPal. Чтобы узнать, как эта компания защищает ваши данные, пожалуйста, загляните сюда: <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "${servercountry} — ваша предпочитаемая страна/регион. Желаете ли вы сменить страну и валюту?",
    "paypalBtn": "Оплатить сейчас по карточке",
    "paypalOr": "Или",
    "paypalCard1": "Имя владельца карты (необязательно)",
    "paypalCard2": "Номер карточки",
    "checkUserID": "Ссылка",
    "success": "УСПЕХ",
    "changeCurrencyContent": "Желаете ли вы сменить регион и валюту на соответствующие вашим игровым настройкам: ${servercountry}?",
    "productDescription": "Фермобаксы — это эквивалент наличных, который можно использовать для покупки любых наборов и предложений в игре.",
    "payButton": "ОПЛАТИТЬ",
    "userIdNotice": "Пожалуйста, введите свой ID пользователя, чтобы сначала подключить ваш игровой аккаунт",
    "account": "Аккаунт",
    "card": "Карта",
    "notification": "Введите свой игровой ID, чтобы привязать ваш аккаунт, выберите желаемые предметы и заплатите, используя предпочитаемый вами способ оплаты. После перезагрузки игры приобретённые предметы появятся на вашем аккаунте и их можно будет использовать.\n\nЕсли у вас есть какие-либо вопросы, пожалуйста, свяжитесь со службой поддержки игры.",
    "rongluRank": "Уровень топки:",
    "tips": "Как этим воспользоваться?",
    "checkTIps1": "Подтверждаю, что я прочитал(а) и соглашаюсь с <a :href=\"policyUrl\">политикой конфиденциальности</a>, <a :href=\"serviceURl\">пользовательским соглашением</a> и <a :href=\"paymentURl\">условиями платежа</a>.",
    "checkTIps2": "Пожалуйста, прочтите и поставьте галочку",
    "selectTips": "(Будет выбрана валюта последней внутриигровой покупки)",
    "koPayTips": "Если ваша банковская карта использовала южнокорейские воны в качестве иностранной валюты, то будет использован сервис динамической конвертации валюты (DCC), и сторонний посредник (а не этот вебсайт) может снять с вас дополнительную оплату за обработку запроса.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Чек",
    "transactionId": "ID транзакции",
    "transactionDate": "Дата транзакции",
    "totalAmount": "Общая сумма",
    "paymentMethod": "Способ платежа",
    "description": "Описание",
    "game": "Игра",
    "quantity": "Количество",
    "price": "Цена",
    "amount": "Сумма",
    "total": "Общая сумма",
    "footTitle": "Примечания",
    "footContent": "Благодарим вас за поддержку Century Games!",
    "button1": "Получить чек",
    "button2": "Назад без чека",
    "giveupInvoice": "Вы не получите чек за эту покупку. Подтверждаете?"
  },
  "payment": {
    "card": "Кредитная карта / Дебетовая карта",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "СТРАНА / РЕГИОН",
    "Africa": "Африка",
    "America": "Америка",
    "Asia": "Азия",
    "Europe": "Европа",
    "Oceania": "Океания",
    "ZA": "ЮАР",
    "US": "США",
    "HK": "Гонконг, Китай",
    "JP": "Япония",
    "KR": "Корея",
    "SG": "Сингапур",
    "SA": "Саудовская Аравия",
    "IQ": "Ирак",
    "TW": "Тайвань, Китай",
    "TH": "Таиланд",
    "GB": "Великобритания",
    "AU": "Австралия",
    "countryLanguage1": "ЯЗЫК",
    "AE": "Объединённые Арабские Эмираты",
    "DE": "Германия",
    "PT": "Португалия",
    "RU": "Россия",
    "ES": "Испания",
    "CH": "Швейцария",
    "TR": "Турция",
    "KW": "Кувейт",
    "QA": "Катар",
    "PL": "Польша",
    "ID": "Индонезия",
    "IT": "Италия",
    "IN": "Индия",
    "FR": "Франция",
    "CA": "Канада",
    "NL": "Нидерланды",
    "AT": "Австрия",
    "RS": "Сербия",
    "SE": "Швеция",
    "MY": "Малайзия",
    "BE": "Бельгия",
    "DK": "Дания",
    "FI": "Финляндия",
    "PH": "Филиппины",
    "NO": "Норвегия",
    "BR": "Бразилия",
    "NZ": "Новая Зеландия",
    "UA": "Украина",
    "RO": "Румыния"
  },
  "extra_info": {
    "kingdom": "Государство: #"
  },
  "adyen": {
    "note": "Платёжные услуги предоставлены Adyen и предлагают вам безопасные транзакции с сертификацией PCI DSS высочайшего уровня от международных кредитных организаций, поддерживающие платежи как по местным, так и по заграничным картам.",
    "note2": "Примечание: поставьте галочку рядом с «Сохранить для следующего платежа», чтобы сохранить информацию о вашей платежной карте в текущем браузере для будущих платежей."
  },
  "pay": {
    "error1": "Если что-то пойдёт не так, попробуйте позже или используйте другой метод оплаты. Если у вас остались вопросы, пожалуйста, свяжитесь с нашей службой поддержки."
  },
  "meta": {
    "title": "Магазин Family Farm Adventure",
    "description": "Магазин Family Farm Adventure — это официальный магазин игры Family Farm Adventure, который предоставляет игрокам возможность приобрести игровые наборы и самоцветы со скидкой.",
    "keywords": "ферма, культивация, рынок, улучшение, исследование, карта, персонаж, уровень, симулятор, стратегия, платить, магазин, пополнение, платёж"
  }
};


// WEBPACK FOOTER //
// ./src/lang/RU.js